export interface IMenuItem {
  title: string;
  href: string;
  subItems?: IMenuItem[];
  matches?: string[];
}

const menuItems: IMenuItem[] = [
  {
    title: "환경영향평가 안내",
    href: "/about",
    subItems: [
      {
        title: "제도 안내",
        href: "/about/system",
      },
      {
        title: "법령 정보",
        href: "/about/ordinance",
      },
    ],
  },
  {
    title: "평가정보조회",
    href: "/project",
    subItems: [],
    matches: ["/project/[idx]"],
  },
  {
    title: "도민참여",
    href: "/opinion",
    subItems: [
      {
        title: "공고 · 공람",
        href: "/opinion/decision",
        matches: ["/opinion/decision/[idx]"],
      },
      {
        title: "주민의견 제출",
        href: "/opinion/participation",
        matches: [
          "/opinion/participation/[projectIdx]",
          "/opinion/participation/[projectIdx]/report/add",
          "/opinion/participation/[projectIdx]/report/[idx]",
        ],
      },
    ],
  },
  {
    title: "게시판",
    href: "/board",
    subItems: [
      {
        title: "공지사항",
        href: "/board/notice",
        matches: ["/board/notice/[idx]"],
      },
      {
        title: "자료실",
        href: "/board/document",
        matches: ["/board/document/[idx]"],
      },
    ],
  },
];

export default menuItems;
